var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":"ค่าใช้จ่าย"}}),_c('van-row',[_c('CarList',{attrs:{"onChange":_vm.onCarChange}}),(_vm.trips.length === 0)?_c('van-empty',{attrs:{"description":"ไม่มีรายการค่าใช้จ่าย"}}):_vm._e()],1),_c('Tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }